import { Button, DataState, EmptyState, useStore } from "@thekrystalship/krystal";
import { serversStore } from "../lib/stores.js";

// ServerGate — the async-state gate for the server-detail route. `serverForRender`
// is legitimately null in three non-crash cases: the servers store is still on its
// first fetch (a deep-link / hard refresh lands here before it resolves), that
// first fetch FAILED, or the store is loaded but no server carries this id. We
// discriminate them off the store's own state machine and render an honest
// loading / error / not-found surface — NEVER ServerDetailPage with a null server,
// whose every child dereferences `server.*` and would throw into the content
// boundary (the crash this replaces). `everLoaded` is the real "first fetch
// finished" signal: a warm refresh preserves the list, so a null past everLoaded
// is a true 404, not a transient.
function ServerGate({ id, onBack, onRetry }) {
  const status = useStore(serversStore, s => s.status);
  const everLoaded = useStore(serversStore, s => s.everLoaded);
  const failed = !everLoaded && status === "error";
  return (
    <DataState loading={!everLoaded && !failed} skeletonLines={4}
      error={failed && "Couldn't load your servers. The server list didn't load, so this page can't open yet."}
      onRetry={onRetry} retryLabel="Try again" isEmpty
      empty={(
        <EmptyState icon="server-off" title="Server not found"
          actions={<Button icon="arrow-left" onClick={onBack}>Back to servers</Button>}>
          No server with the id "{id}" is on any connected host — it may have been removed, or the link is out of date.
        </EmptyState>
      )} />
  );
}

export { ServerGate };
